import { z } from "zod";

import { MONITORING_STATUSES, RECOMMENDATION_ACTIONS } from "../types/types";

const listSchema = z.object({
	status: z.enum(MONITORING_STATUSES).optional().catch(undefined),
	action: z.enum(RECOMMENDATION_ACTIONS).optional().catch(undefined),
	q: z.string().optional().catch(undefined),
});

export type MonitoringListSearch = z.infer<typeof listSchema>;

/** Optional, self-healing filters: a malformed URL just loses the bad key. */
export const validateMonitoringListSearch = (
	search: Record<string, unknown>,
): MonitoringListSearch => {
	const parsed = listSchema.parse(search);
	return {
		...(parsed.status && { status: parsed.status }),
		...(parsed.action && { action: parsed.action }),
		...(parsed.q?.trim() && { q: parsed.q }),
	};
};

export const TREND_RANGES = ["6", "12", "all"] as const;
export type TrendRange = (typeof TREND_RANGES)[number];

const detailSchema = z.object({
	range: z.enum(TREND_RANGES).optional().catch(undefined),
	page: z.coerce.number().int().min(1).optional().catch(undefined),
});

export type MonitoringDetailSearch = z.infer<typeof detailSchema>;

export const validateMonitoringDetailSearch = (
	search: Record<string, unknown>,
): MonitoringDetailSearch => {
	const parsed = detailSchema.parse(search);
	return {
		...(parsed.range && parsed.range !== "6" && { range: parsed.range }),
		...(parsed.page && parsed.page > 1 && { page: parsed.page }),
	};
};
